import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
// import Scrollbar from "smooth-scrollbar"

/*
*
* Shopify Media - Product Media 
*
* @link https://photoswipe.com/documentation/getting-started.html
* @link https://shopify.dev/docs/themes/liquid/reference/objects/media
* 
*/
theme.media = {

    pswp: '',
    pswpMedia: [],
    pswpOptions: {},
    pswpElement: '',
    pswpClass: PhotoSwipeUI_Default,

    init: function() {

        // Loop through elements and determine what to do with them
        let $media = $('[data-additional-image]')
        $.each($media, function() {

            // What type is it?
            // @link https://shopify.dev/docs/themes/liquid/reference/objects/media
            let type = $(this).data('media-type')

            switch (type) {
                // Push an image onto the stack.
                case 'image':
                    theme.media.pswpMedia.push({
                        src: $(this).data('img-full'),
                        w: $(this).data('img-width'),
                        h: $(this).data('img-height')
                    })
                    break;
                // Push the media tag onto the stack.
                case 'video':
                    // Embedded video
                    let video_html = $(this).find('[data-media-html]').html()
                    if (video_html) {
                        theme.media.pswpMedia.push({
                            html: video_html,
                        })
                    }                    
                    break;
                // Push the <iframe> onto the stack.
                case 'external_video':
                    let external_video_html = $(this).find('[data-media-html]').html()
                    if (external_video_html) {
                        theme.media.pswpMedia.push({
                            html: external_video_html,
                        })
                    }
                    break;      
                // 3D Model, Integrate into PSWP if required
                case 'model':
                    break;
                default:
                    break;
            }

        })

        this.glide()
        this.events()

        // $('[data-scrollbar]').css({
        //     height: $('[data-main-image]').height() + "px"
        // })
        
        // Scrollbar.initAll();

        $('[data-additional-image-container]').removeClass('invisible opacity-0')

    },

    // Setup the product carousel if required
    glide: function() {
        if ($('.glide-product-media').length > 0) {
            SureifyCarousel('.glide-product-media')
        }
    },

    // Setup the product events
    events: function() {

        // Setup gallery
        this.pswpElement = document.querySelectorAll('.pswp')[0]
        theme.media.pswpOptions = {
            index: 0
        }

        // When the main image is clicked, open a gallery
        $('[data-main-image]').on('click', function(e) {

            // Stop default.
            e.preventDefault()

            // Constructor
            theme.media.pswp = new PhotoSwipe(
                theme.media.pswpElement, 
                theme.media.pswpClass, 
                theme.media.pswpMedia, 
                theme.media.pswpOptions,
            )
            
            // Init.
            theme.media.pswp.init()
            
            // Listen.
            theme.media.pswp.listen('close', function() {
                theme.media.reset()
            });

        })

        // When an additional image is clicked, replace the source
        $('[data-additional-image]').on('click', function(e) {

            // Stop default.
            e.preventDefault()

            // Hide loader
            $('[data-loader]').removeClass('opacity-0 invisible')

            // Get some data from the new image
            let index = $(this).data('img-index')
            let src = $(this).data('img-src')
            let type = $(this).data('media-type')

            // Determine if the image being replaced is a video
            if (type == 'video'  || type == 'external_video') {
                $('[data-main-image-video-icon]').removeClass('hidden')
            } else {
                $('[data-main-image-video-icon]').addClass('hidden')
            }

            // Make sure the index of the gallery is updated
            theme.media.pswpOptions.index = index

            // Get the new image
            var img = new Image();
            img.src = src;
            img.onload = function() {
                $('[data-loader]').addClass('opacity-0 invisible')
                $('[data-main-image-src]').attr('src', src)                            // Scroll to it
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
            };



        })

    },

    // Reset all videos by pausing them
    reset: function() {
        let videos = document.querySelectorAll('video');
        videos.forEach(function(video) {
            // Pause.
            video.pause()
        })
    }

}

// Boot
$(function(){
    theme.media.init()
})